import { API } from "../../types";

export type VerseMode = 'full' | 'classic' | 'manual';

export interface VerseData {
  mode: VerseMode;
  seedOffset: number;
  manualBook?: string;
  manualChapter?: string;
  manualVerse?: string;
  manualVersionIds?: string[];
  verseFontSize: number;
  verseFontWeight: number;
  referenceFontSize: number;
  referenceFontWeight: number;
}

export type Props = API<VerseData>;

export const defaultData: VerseData = {
  mode: 'classic',
  seedOffset: 0,
  verseFontSize: 16,
  verseFontWeight: 500,
  referenceFontSize: 12,
  referenceFontWeight: 500,
};
